import script from "./OrderForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderForm.vue?vue&type=script&setup=true&lang=ts"

import "./OrderForm.vue?vue&type=style&index=0&id=0dd3c5a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd3c5a0"]])

export default __exports__